module.exports = __webpack_public_path__ + "static/media/solutions.2a96dc34.png";